import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { DefaultButton } from 'common/components';
import { editDepositBonus } from '../../api';

const EditBonusRateForm = ({ item, toggleModal, onRefresh }) => {
  const [rate, setRate] = useState(item?.bonusRate || '');
  const [loading, setLoading] = useState(false);

  const handleFinalSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await editDepositBonus(item.id, { bonus_rate: rate });
      toggleModal();
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="RejectModal__content">
      <form onSubmit={handleFinalSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '10px', fontSize: '14px', fontWeight: 'bold' }}>
            <FormattedMessage id="justNewBonusRate" /> (%)
          </label>
          <input
            type="number"
            value={rate}
            onChange={e => setRate(e.target.value)}
            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
            required
            step="0.01"
            disabled={loading}
          />
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <DefaultButton textId="justCancel" onClick={toggleModal} type="button" />
          <DefaultButton textId="justSave" type="submit" loading={loading} disabled={loading} filled />
        </div>
      </form>
    </div>
  );
};

export default EditBonusRateForm;
